export const dimensionsLabels: {
  [key: string]: string;
} = {
  length: 'Длина, м',
  width: 'Ширина, м',
  area: 'Площадь, м²',
  layerThickness: 'Толщина слоя, мм',
  height: 'Высота, м',
  doors: 'Количество дверей',
  windows: 'Количество окон',
};

export const MEASUREMENT_TYPE = 'measurement';

export const dimensionsErrors: {
  [key: string]: {
    required: string;
    value: RegExp;
    pattern: string;
  };
} = {
  length: {
    required: 'Введите длину',
    value: /^[0-9]{1,3}([,.][0-9]{1,2})?$/,
    pattern: 'Формат: XXX.XX',
  },
  width: {
    required: 'Введите ширину',
    value: /^[0-9]{1,3}([,.][0-9]{1,2})?$/,
    pattern: 'Формат: XXX.XX',
  },
  area: {
    required: 'Введите площадь пола',
    value: /^[0-9]{1,3}([,.][0-9]{1,2})?$/,
    pattern: 'Формат: XXX.XX',
  },
  layerThickness: {
    required: 'Введите толщину слоя',
    value: /^[0-9]{1,3}?$/,
    pattern: 'Формат: XXX',
  },
  height: {
    required: 'Введите высоту',
    value: /^[0-9]{1,2}([,.][0-9]{1,2})?$/,
    pattern: 'Формат: XX.XX',
  },
};
